const coSwipers = {};
const coSwiperConfigs = {
  coSwiper1: {
    selector: '.co-case-1-left',
    config: {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: ".co-case-1-left .swiper-button-next",
        prevEl: ".co-case-1-left .swiper-button-prev",
      },
    }
  },
  coSwiper2: {
    selector: '.co-case-2-left',
    config: {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: ".co-case-2-left .swiper-button-next",
        prevEl: ".co-case-2-left .swiper-button-prev",
      },
    }
  },
  coSwiper3: {
    selector: '.co-case-3-left',
    config: {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: ".co-case-3-left .swiper-button-next",
        prevEl: ".co-case-3-left .swiper-button-prev",
      },
    }
  },
  coSwiper4: {
    selector: '.co-case-4-left',
    config: {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: ".co-case-4-left .swiper-button-next",
        prevEl: ".co-case-4-left .swiper-button-prev",
      },
    }
  },
  coSwiper5: {
    selector: '.co-case-5-left',
    config: {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: ".co-case-5-left .swiper-button-next",
        prevEl: ".co-case-5-left .swiper-button-prev",
      },
    }
  },
};
const breakpoint = window.matchMedia('(max-width: 989px)');
function handleSwipers() {
  Object.keys(coSwiperConfigs).forEach(key => {
    const { selector, config } = coSwiperConfigs[key];
    if (breakpoint.matches) {
      if (!coSwipers[key]) {
        if (document.querySelector(selector)) {
          coSwipers[key] = new Swiper(selector, config);
        }
      }
    } else {
      if (coSwipers[key]) {
        coSwipers[key].destroy(true, true);
        coSwipers[key] = null;
      }
    }
  });
}
handleSwipers();
breakpoint.addEventListener('change', handleSwipers);
